import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useTimezone } from "../helpers/hooks";
import { useDatesContext } from "context/DatesContext";

export const useOrderPaymentDailySummary = ({
  storeId,
  start,
  end,
  type,
  payment,
}) => {
  const { orderPaymentDailySummary, loading } = useAllOrderPaymentDailySummary(
    storeId,
    start,
    end,
    type,
    payment
  );
  return {
    loading,
    orderPaymentDailySummary,
  };
};

function useAllOrderPaymentDailySummary(storeId, start, end, type, payment) {
  const timezone = useTimezone();
  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl(
    "useAllOrderPaymentDailySummary",
    60 * 1000
  );
  const { data, loading, error } = useQuery(
    gql`
      query GetOrderPaymentDailySummary(
        $orderPaymentDailySummaryInput: OrderPaymentDailySummaryInput!
      ) {
        orderPaymentDailySummary(input: $orderPaymentDailySummaryInput) {
          _id {
            start
            end
            type
            code
            description
            year
            month
            dayOfMonth
          }
          total
          count
        }
      }
    `,
    {
      variables: {
        orderPaymentDailySummaryInput: {
          timezone,
          storeId,
          start,
          end,
          type,
          payment,
        },
      },
      fetchPolicy,
    }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const orderPaymentDailySummary = data?.orderPaymentDailySummary ?? [];
  return { orderPaymentDailySummary, loading };
}

export const useOrderPaymentMonthlySummary = ({
  storeId,
  start,
  end,
  type,
  payment,
}) => {
  const { orderPaymentMonthlySummary, loading } =
    useAllOrderPaymentMonthlySummary(storeId, start, end, type, payment);
  return {
    loading,
    orderPaymentMonthlySummary,
  };
};

function useAllOrderPaymentMonthlySummary(storeId, start, end, type, payment) {
  const timezone = useTimezone();
  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl(
    "useAllOrderPaymentMonthlySummary",
    60 * 1000
  );
  const { data, loading, error } = useQuery(
    gql`
      query GetOrderPaymentMonthlySummary(
        $orderPaymentMonthlySummaryInput: OrderPaymentMonthlySummaryInput!
      ) {
        orderPaymentMonthlySummary(input: $orderPaymentMonthlySummaryInput) {
          _id {
            start
            end
            type
            code
            description
            year
            month
          }
          total
          count
        }
      }
    `,
    {
      variables: {
        orderPaymentMonthlySummaryInput: {
          timezone,
          storeId,
          start,
          end,
          type,
          payment,
        },
      },
      fetchPolicy,
    }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const orderPaymentMonthlySummary = data?.orderPaymentMonthlySummary ?? [];
  return { orderPaymentMonthlySummary, loading };
}

export const useOrderPaymentHourlySummary = ({
  storeId,
  start,
  end,
  type,
  payment,
}) => {
  const { orderPaymentHourlySummary, loading } =
    useAllOrderPaymentHourlySummary(storeId, start, end, type, payment);
  return {
    loading,
    orderPaymentHourlySummary,
  };
};

function useAllOrderPaymentHourlySummary(storeId, start, end, type, payment) {
  const timezone = useTimezone();
  const { getCacheControl } = useDatesContext();
  const fetchPolicy = getCacheControl(
    "useAllOrderPaymentHourlySummary",
    60 * 1000
  );
  const { data, loading, error } = useQuery(
    gql`
      query GetOrderPaymentHourlySummary(
        $orderPaymentHourlySummaryInput: OrderPaymentHourlySummaryInput!
      ) {
        orderPaymentHourlySummary(input: $orderPaymentHourlySummaryInput) {
          _id {
            start
            end
            type
            code
            description
            year
            month
            dayOfMonth
            hour
          }
          total
          count
        }
      }
    `,
    {
      variables: {
        orderPaymentHourlySummaryInput: {
          timezone,
          storeId,
          start,
          end,
          type,
          payment,
        },
      },
      fetchPolicy,
    }
  );
  if (error) {
    throw new Error(`Failed to fetch tasks: ${error.message}`);
  }
  // If the query has finished, return the tasks from the result data
  // Otherwise, return an empty list
  const orderPaymentHourlySummary = data?.orderPaymentHourlySummary ?? [];
  return { orderPaymentHourlySummary, loading };
}
